module.exports = __webpack_public_path__ + "static/img/logo_kcc_news.a17287c0.png";